<template>
  <InternalNavbar :navigation="navigation" auto-hide />
</template>

<script>
import InternalNavbar from '@@/layout/InternalNavbar';

export default {
  name: 'CampaignInternalNav',
  components: {
    InternalNavbar,
  },
  computed: {
    navigation() {
      const nav = [];

      nav.push({
        to: { name: 'basic-ads-campaigns-list' },
        text: this.$t('ADVERTISEMENT.BASIC_ADS_CAMPAINGS_LIST_TITLE'),
      });

      nav.push({
        to: { name: 'discovery-ads-campaigns-list' },
        text: this.$t('ADVERTISEMENT.DISCOVERY_ADS_CAMPAINGS_LIST_TITLE'),
      });

      nav.push({
        to: { name: 'search-ads-campaigns-list' },
        text: this.$t('ADVERTISEMENT.SEARCH_ADS_CAMPAINGS_LIST_TITLE'),
      });

      return nav;
    },
  },
};
</script>
